var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 14.2857L18.8429 10L11.4286 5.71429V14.2857ZM27.9429 3.1C28.1286 3.77143 28.2571 4.67143 28.3429 5.81429C28.4429 6.95714 28.4857 7.94286 28.4857 8.8L28.5714 10C28.5714 13.1286 28.3429 15.4286 27.9429 16.9C27.5857 18.1857 26.7571 19.0143 25.4714 19.3714C24.8 19.5571 23.5714 19.6857 21.6857 19.7714C19.8286 19.8714 18.1286 19.9143 16.5571 19.9143L14.2857 20C8.3 20 4.57143 19.7714 3.1 19.3714C1.81429 19.0143 0.985714 18.1857 0.628572 16.9C0.442857 16.2286 0.314286 15.3286 0.228572 14.1857C0.128572 13.0429 0.0857142 12.0571 0.0857142 11.2L0 10C0 6.87143 0.228572 4.57143 0.628572 3.1C0.985714 1.81429 1.81429 0.985714 3.1 0.628572C3.77143 0.442857 5 0.314286 6.88571 0.228571C8.74286 0.128571 10.4429 0.0857142 12.0143 0.0857142L14.2857 0C20.2714 0 24 0.228572 25.4714 0.628572C26.7571 0.985714 27.5857 1.81429 27.9429 3.1Z",
    fill: "#F7C35F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/YoutubeIcon.ee1a234c4acd595988a7c98169e79a13.svg";
export { ForwardRef as ReactComponent };